import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController, NavParams } from '@ionic/angular';
import { SupportedCurrencyService } from '../../services/supported-currency.service';
import { CashTrackingService } from '../../services/cash-tracking.service';
import { UserService } from '../../services/user.service';
import * as moment from 'moment-timezone';

@Component({
    selector: 'app-cash-tracking-cash-movements',
    templateUrl: './cash-tracking-cash-movements.page.html',
    styleUrls: ['./cash-tracking-cash-movements.page.scss'],
})
export class CashTrackingCashMovementsPage implements OnInit {

    moment = moment;
    currency_id = null;
    supported_currency = null;
    cash_movements = [];

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private supportedCurrencyService: SupportedCurrencyService,
        private cashTrackingService: CashTrackingService,
        public navParams: NavParams,
        private userService: UserService
    ) { }

    ngOnInit() {

        if(this.navParams.get('currency_id')) {

            this.currency_id = this.navParams.get('currency_id');

            this.supportedCurrencyService.getSupportedCurrency(this.currency_id).then((currency) => {
                if(currency) {
                    this.supported_currency = currency;
                }
            })
            .catch(() => {});

            this.cashTrackingService.getCashMovements().then((cash_movements: any) => {
                if(cash_movements) {
                    /*
                    cash_movements.sort((a, b) => {
                        if (a.date < b.date) { return 1; }
                        if (a.date > b.date) { return -1; }
                        return 0;
                    });
                    */
                    for(let i = 0; i < cash_movements.length; i++) {
    
                        if(cash_movements[i].currency_id == this.currency_id) {
    
                            let cash_movement = {};
                            cash_movement['date'] = cash_movements[i].date;
                            cash_movement['price'] = cash_movements[i].price;
    
                            if(cash_movements[i].note) {
                                cash_movement['note'] = cash_movements[i].note;
                            }
    
                            this.userService.getUsers().then((users: any) => {
                                if(users) {
                                    for(let j = 0; j < users.length; j++) {
                                        if(users[j].id == cash_movements[i].user_id) {
                                            cash_movement['user_id'] = users[j].id;
                                            cash_movement['user_first_name'] = users[j].first_name;
                                            cash_movement['user_last_name'] = users[j].last_name;
                                        }
                                    }
                                }
    
                            });
    
                            this.cash_movements.push(cash_movement);
    
                        }
    
                    }
                }
            })
            .catch(() => {});

        }
    }

    close() {
        this.modalController.dismiss();
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

}
